/* eslint-disable import/no-mutable-exports */
import StripePaymentContainer from "./StripePaymentContainer";

export default StripePaymentContainer;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/StripePaymentContainer/index.js